import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PeriodoContableForm } from "./PeriodoContableForm";
import dayjs from "dayjs";
import { CloseBtn, FormUi, Modal, SaveBtn } from "../../../ui";
import { useEffect, useRef } from "react";
import {
  periodoContableClearActive,
  periodoContableStartAdd,
  periodoContableStartUpdate,
} from "../../../../actions";
import { DateFormats } from "../../../../types/typesConstants";

const initialValues = (data = {}) => ({
  id: data?.id || new dayjs().valueOf(),
  nombre: data?.nombre || null,
  fechainicio: dayjs(data?.fechainicio) || null,
  fechafin: dayjs(data?.fechafin) || null,
  estado: data?.estado || null,
});
// reset form fields when modal is form, closed
const useResetFormOnCloseModal = ({ form, open, activePeriodoContable }) => {
  const prevOpenRef = useRef();

  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) form.resetFields();
    else {
      //Abrir Modal
      if (activePeriodoContable) {
        //entro editar
        form.setFieldsValue({
          ...activePeriodoContable,
          fechainicio: dayjs(activePeriodoContable.fechainicio),
          fechafin: dayjs(activePeriodoContable.fechafin),
        });
      } else {
        //entro nuevo
        form.setFieldValue("id", new dayjs().valueOf());
      }
    }
  }, [form, prevOpen, open]);
};
export const PeriodoContableModal = ({ open, handleCloseModal }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activePeriodoContable } = useSelector((state) => state.inventario);
  useResetFormOnCloseModal({
    form,
    open,
    activePeriodoContable,
  });

  const handleClose = () => {
    dispatch(periodoContableClearActive());
    handleCloseModal();
  };
  const handleSubmit = (values) => {
    values = {
      ...values,
      fechainicio: dayjs(values?.fechainicio).format(DateFormats.backend),
      fechafin: dayjs(values?.fechafin).format(DateFormats.backend),
    };
    if (activePeriodoContable) dispatch(periodoContableStartUpdate(values));
    else dispatch(periodoContableStartAdd(values));
    handleClose();
  };
  return (
    <Modal
      title="Registro de periodo contable"
      open={open}
      onCancel={handleClose}
      width="50%"
      footer={[
        <CloseBtn key="back" onClick={handleClose} />,
        <SaveBtn key="submit" htmlType="submit" form="PeriodoContableForm" />,
      ]}
      forceRender
    >
      <FormUi
        name="PeriodoContableForm"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(activePeriodoContable)}
        handleSubmit={handleSubmit}
      >
        <PeriodoContableForm />
      </FormUi>
    </Modal>
  );
};
